<template>
  <div class="d-flex" :class="justifyContentClass">
    <button
        type="button"
        :class="btnClass"
        @click="$emit('clicked')"
    >
      {{ text }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: 'افزودن'
    },
    btnClass: {
      type: String,
      default: 'btn btn-primary btn-submit-1 custom-p-2 btn-add'
    },
    justifyContentClass: {
      type: String,
      default: 'justify-content-end'
    }
  }
}
</script>
<style scoped lang="scss">
.btn-add{
  font-size: 0.9vw !important;
  padding: 0.5vw;
  width: 6vw;
}
</style>